import { CLASS_REFUND_POLICY, COMMERCE_REFUND_POLICY } from '@consts/products';
import { ProductModel } from '@models/product';
import React from 'react';

export const CommerceRefundPolicy: React.FC<{ data: ProductModel }> = (props) => {
  const data = props.data;

  if (!data?.refundPolicies || data?.refundPolicies.length === 0) {
    return <div></div>;
  }

  return (
    <div style={{ padding: '20px 16px' }}>
      <div className="product-detail-title">교환/환불정책</div>
      <div style={{ color: '#66686b', fontSize: '13px', lineHeight: '20px', whiteSpace: 'pre-wrap' }}>
        {data?.refundPolicies[0]}
      </div>
      <div className="product-detail-subtitle">교환 안내</div>
      <div style={{ color: '#66686b', fontSize: '13px', lineHeight: '20px', whiteSpace: 'pre-wrap' }}>
        {data?.refundPolicies[1]}
      </div>
      <div className="product-detail-subtitle">환불 안내</div>
      <div style={{ color: '#66686b', fontSize: '13px', lineHeight: '20px', whiteSpace: 'pre-wrap' }}>
        {data?.refundPolicies[2]}
      </div>
      <div className="product-detail-subtitle">교환 및 환불 신청 방법</div>
      <div style={{ color: '#66686b', fontSize: '13px', lineHeight: '20px', whiteSpace: 'pre-wrap' }}>
        {data?.refundPolicies[3]}
      </div>
    </div>
  );
};

export const ClassRefundPolicy: React.FC<{ data: ProductModel }> = (props) => {
  const data = props.data;
  const refundPolicies: string[] = (data?.refundPolicyText || CLASS_REFUND_POLICY)
    .split('\n')
    .map((line: string) => {
      return line.trim().replace(/^-/, '');
    })
    .filter((line: string) => line.length > 0);

  return (
    <div
      style={{
        marginTop: '32px',
        paddingLeft: '16px',
        paddingRight: '16px',
        paddingBottom: 0,
      }}>
      <div
        style={{
          fontSize: '20px',
          fontWeight: 'bold',
          lineHeight: '26px',
          letterSpacing: -0.6,
        }}>
        환불정책
      </div>
      {data?.classTermsText ? (
        <div style={{ marginTop: '8px', color: '#424242', whiteSpace: 'pre-wrap', lineHeight: '20px' }}>
          {data?.classTermsText}
        </div>
      ) : (
        refundPolicies.map((item: string, index) => {
          return (
            <div
              key={`terms-${index}`}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                marginTop: '8px',
                marginLeft: '4px',
              }}>
              <div
                style={{
                  backgroundColor: '#66686b',
                  borderRadius: '50%',
                  width: '4px',
                  height: '4px',
                  marginRight: '10px',
                  marginTop: '8px',
                }}
              />
              <div
                style={{
                  fontSize: '14px',
                  color: '#424242',
                  lineHeight: '22px',
                  width: '100%',
                  letterSpacing: -0.4,
                  flexWrap: 'wrap',
                }}>
                {item}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export const ProductRefundPolicy: React.FC<{ data: ProductModel }> = (props) => {
  const data = props.data;

  if (!data?.refundPolicyText && data?.refundPolicies && data?.refundPolicies.length > 0) {
    return <CommerceRefundPolicy data={props.data} />;
  }

  if (!data?.refundPolicyText && data?.classTermsText) {
    return <ClassRefundPolicy data={props.data} />;
  }

  const refundPolicies: string[] = (
    data?.refundPolicyText || (data?.saleType === 'class' ? CLASS_REFUND_POLICY : COMMERCE_REFUND_POLICY)
  )
    .split('\n')
    .map((line: string) => {
      return line.trim();
    })
    .filter((line: string) => line.length > 0);

  return (
    <div
      style={{
        marginTop: '32px',
        paddingLeft: '16px',
        paddingRight: '16px',
        paddingBottom: 0,
      }}>
      <div
        style={{
          fontSize: '20px',
          fontWeight: 'bold',
          lineHeight: '26px',
          letterSpacing: -0.6,
        }}>
        환불정책
      </div>
      <div style={{ marginTop: '8px' }}>
        {refundPolicies.map((item: string, index) => {
          return (
            <div
              key={`terms-${index}`}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
                marginTop: '8px',
                marginLeft: '4px',
              }}>
              <div
                style={{
                  fontSize: '14px',
                  color: '#424242',
                  lineHeight: '22px',
                  width: '100%',
                  letterSpacing: -0.4,
                  flexWrap: 'wrap',
                }}>
                {item}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
